"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../ThemeProvider");

var _ControlLabel = _interopRequireDefault(require("react-bootstrap/lib/ControlLabel"));

var _HelpBlock = _interopRequireDefault(require("react-bootstrap/lib/HelpBlock"));

var _FormGroup = _interopRequireDefault(require("react-bootstrap/lib/FormGroup"));

var _Col = _interopRequireDefault(require("react-bootstrap/lib/Col"));

var _GlyphIcon = _interopRequireDefault(require("../GlyphIcon"));

var _Tooltip = require("../Tooltip");

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/* eslint complexity: ["error", 100] */
function FormBase(_ref) {
  var Control = _ref.Control,
      optional = _ref.optional,
      className = _ref.className,
      classes = _ref.classes,
      id = _ref.id,
      label = _ref.label,
      _ref$localization = _ref.localization,
      l = _ref$localization === void 0 ? function (key) {
    return key;
  } : _ref$localization,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? null : _ref$error,
      _ref$info = _ref.info,
      info = _ref$info === void 0 ? null : _ref$info,
      _ref$colwidths = _ref.colwidths,
      colwidths = _ref$colwidths === void 0 ? [3, 4, 5] : _ref$colwidths,
      _ref$additionals = _ref.additionals,
      additionals = _ref$additionals === void 0 ? null : _ref$additionals,
      _ref$controlClassName = _ref.controlClassName,
      controlClassName = _ref$controlClassName === void 0 ? '' : _ref$controlClassName,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["Control", "optional", "className", "classes", "id", "label", "localization", "error", "info", "colwidths", "additionals", "controlClassName"]);
  var errorComponent = error !== null ? /*#__PURE__*/_react["default"].createElement(_HelpBlock["default"], {
    id: "error-".concat(id)
  }, error) : null;
  var icon = info === null ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "stilo-input-icon"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip.OverlayTrigger, {
    id: "overlay-trigger-".concat(id),
    overlay: /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
      id: "tooltip-".concat(id)
    }, info.text),
    placement: "right"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "icon-container"
  }, "\xA0", /*#__PURE__*/_react["default"].createElement(_GlyphIcon["default"], {
    glyph: info.icon
  }))));
  var control = Control ? /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: colwidths[1],
    className: 'cell-2'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "stilo-input-horizontal"
  }, /*#__PURE__*/_react["default"].createElement(Control, (0, _extends2["default"])({
    id: id
  }, props, {
    localization: l
  }))), /*#__PURE__*/_react["default"].createElement("div", null, errorComponent)) : null;
  var options = icon || optional || additionals ? /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: colwidths[2],
    className: 'cell-3'
  }, icon, optional ? /*#__PURE__*/_react["default"].createElement("span", {
    className: 'optional'
  }, "(", l('Optional'), ")") : null, additionals) : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.FormBase, " stilo-form ").concat(className ? className : '', " ").concat(props.disabled && 'disabled')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-horizontal"
  }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    validationState: error != null ? 'error' : null,
    className: 'fluid-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'row'
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    className: "cell-1 label-left ".concat(controlClassName),
    componentClass: _ControlLabel["default"],
    "data-ctrl-name": "label-".concat(id),
    xs: colwidths[0]
  }, label), control, options))));
}

FormBase.propTypes = {
  className: _propTypes["default"].string,
  optional: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  colwidths: _propTypes["default"].array,
  name: _propTypes["default"].string,
  style: _propTypes["default"].object,
  label: _propTypes["default"].node,
  localization: _propTypes["default"].func,
  error: _propTypes["default"].string,
  id: _propTypes["default"].string,
  handleChange: _propTypes["default"].func,
  info: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    icon: _propTypes["default"].string
  }),
  classes: _propTypes["default"].object,
  additionals: _propTypes["default"].node,
  Control: _propTypes["default"].func,
  controlClassName: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
var ThemedStiloFormBase = (0, _ThemeProvider.withStyles)(_style["default"])(FormBase);
var _default = ThemedStiloFormBase;
exports["default"] = _default;
//# sourceMappingURL=base.js.map